export const getWindow = (): Window | undefined =>
	typeof window === 'undefined' ? undefined : window;
